/** 取指定 vip_type 的月付档；找不到该档时 vip_type=1 回退第一档 */
export const findMonthlyGoodsIdByVipType = (goodsList?: any[], vipType = 1): number | null => {
  if (!Array.isArray(goodsList) || goodsList.length === 0) return null

  const group = goodsList.find((item) => Number(item?.vip_type) === vipType)
    || (vipType === 1 ? goodsList[0] : null)
  const products = Array.isArray(group?.products) ? group.products : []
  const monthly = products.find((item) =>
    item?.billingPeriod === "MONTHLY" || /月|month/i.test(item?.title || ""),
  ) || products[0]
  const goodsId = Number(monthly?.goods_id)
  return Number.isFinite(goodsId) && goodsId > 0 ? goodsId : null
}

/** vip_type: 1 普通/Luxury Premium，取月付档 */
export const findMonthlyPremiumGoodsId = (goodsList?: any[]): number | null =>
  findMonthlyGoodsIdByVipType(goodsList, 1)

/** 次数上限升级：普通会员(vip_type=1)订皇家月会员，其余订 Premium 月会员 */
export const findLimitUpgradeGoodsId = (goodsList?: any[], userVipType?: number | null) =>
  Number(userVipType) === 1
    ? findMonthlyGoodsIdByVipType(goodsList, 2)
    : findMonthlyGoodsIdByVipType(goodsList, 1)
